module.exports = __webpack_public_path__ + "static/img/layout3.f355126f.png";